<template>
    <div class="container" style="min-height: calc(100vh - 40px);">
        <div style="margin-top:10vh;"></div>
        <h1 class="ui-text-center">UIPack Desert</h1>
        <p class="ui-text-center">UIPack Desert introduces a new look that is simpler, more aesthetically pleasing, and optimized for Full Screen Display devices! When you use the UIPack, you can feel our ingenious design and our painstaking work.</p>
        <h2 class="ui-text-center">Release Notes</h2>
        <p class="ui-text-center">UIKit 3, Card Design, Dark Mode, AnimKit, Performance Improvement and More...</p>

        <button class="ui-news-btn" onclick="location.href='https://www.mediafire.com/file/05k1ebp55do4by3/UIPack_3.0_Beta_1.mcpack/file'">
        Download Beta 1
        </button>
        <button class="ui-news-btn mt-4" onclick="location.href='https://www.mediafire.com/file/ejlne9k6nk74dms/UIPack_3.0_Beta_2.mcpack/file'">
        Download Beta 2
        </button>
        <a class="ui-news-btn" href="https://mcpedl.com/uipack-desert/" target="_blank" style="max-width:7em;margin-top:2em;">
            MCPEDL
        </a>
    </div>
</template>

<script>

export default {
}
</script>